import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons/faEllipsisH';

import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { Text, TextType } from 'ui-components/components/text';

import { DeletePackageSetModalWrapper } from '../../../../../../components/modals/multi-package-modal/delete-package-set-modal';
import { emptyObject } from 'ui-components/default-props/empty';
import { messages } from '../../messages';
import style from '../../style.module.less';

const ActionsCell = ({ row }) => {
  const { isFirstInSet, packageSetId } = row?.original || emptyObject;

  if (!isFirstInSet) {
    return null;
  }

  return (
    <DeletePackageSetModalWrapper>
      {({ openModal }) => {
        return (
          <DropdownMenu menuPosition='bottom-right'>
            <DropdownMenuToggler className={style['menu-toggler']} hideChevron theme='link'>
              <div className={style['menu-toggler-contents']}>
                <FontAwesomeIcon icon={faEllipsisH} />
              </div>
            </DropdownMenuToggler>
            <DropdownMenuItem>
              <Text onClick={() => openModal(packageSetId)} textType={TextType.Caption} value={messages.deletePackageSet} />
            </DropdownMenuItem>
          </DropdownMenu>
        );
      }}
    </DeletePackageSetModalWrapper>
  );
};

export const createActionsColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'actions',
  Header: <FormattedMessage {...messages.actionsColumnHeader} />,
  Cell: ActionsCell,
  width: 1,
  minWidth: 100,
  className: style['actions-cell'],
});
